import React from 'react';
import { Stack, Link, Text, Flex } from '@chakra-ui/react';

export default function Footer() {
  return (
    <Stack w="100%" px={5} py={3} bg="#DAF6E9" color="#0B4654" fontSize="14px">
      <Text fontWeight={'bold'}>網頁更新日期:206/9/16</Text>
      <Text fontWeight={'bold'}>
        請使用 1024 *768px 以上(含)解析度與 IE 10+、Chrome
        瀏覽器以取得最佳瀏覽效果
      </Text>
      <Flex alignItems="center">
        <Link href="https://www.epa.gov.tw/Page/41156C14CC997554">
          隱私權政策
        </Link>
        <Text ml={2} mr={2}>
          |
        </Text>
        <Link href="https://www.epa.gov.tw/Page/93E745565929795D">
          網路安全政策
        </Link>
        <Text ml={2} mr={2}>
          |
        </Text>
        <Link href="https://www.epa.gov.tw/Page/981903047CA6500B">
          資訊安全規範(PDF檔)
        </Link>
        <Text ml={2} mr={2}>
          |
        </Text>
        <Link href="https://www.epa.gov.tw/Page/A33D3A6556ABFCD2">
          網站資料開放宣告
        </Link>
        <Text ml={2} mr={2}>
          |
        </Text>
        <Link href="/faq">常見問題</Link>
      </Flex>
    </Stack>
  );
}
